import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Innovaonrentmumbai() {



const cardData = {
  keyword: " Innova On Rent Mumbai",

headingDescription:
  "Omshree Cab offers dependable Innova on rent in Mumbai for travelers looking for spacious, comfortable, and reliable transportation for city travel, airport transfers, family outings, group trips, corporate travel, or outstation journeys. The Toyota Innova is a popular multi‑purpose vehicle known for its roomy interiors, smooth performance, excellent ride quality, and ample luggage space — making it ideal for families, friends, and groups. We provide flexible rental options including one‑way bookings, round trips, hourly rentals, and full‑day plans with transparent pricing and no hidden charges. Each Innova in our fleet is air‑conditioned, regularly serviced, and driven by professional chauffeurs experienced with Mumbai’s roads and traffic conditions. With easy online booking, punctual pickups from any location in Mumbai (including airports, railway stations, hotels, and residences), and 24/7 customer support, renting an Innova in Mumbai becomes a seamless and stress‑free experience.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of Mumbai’s most iconic landmarks located along the Arabian Sea in South Mumbai. Built during the British era, this majestic arch attracts tourists for sightseeing, photography, and ferry rides to Elephanta Island. The lively Colaba area surrounding the monument features cafes, markets, and heritage buildings that reflect Mumbai’s history. Renting an Innova in Mumbai makes it convenient for families or groups to reach this famous location comfortably and begin their city exploration without worrying about traffic or parking."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal road along the Arabian Sea, popularly called the Queen’s Necklace because of the shimmering streetlights at night. Visitors enjoy sunset views, evening strolls, and relaxing sea breezes along this iconic boulevard. The route also connects several major attractions of South Mumbai. Renting an Innova provides a smooth and comfortable ride for group sightseeing, allowing travelers to explore multiple spots conveniently."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most popular seaside destinations known for its sandy shores, lively atmosphere, and famous street food like pav bhaji and bhel puri. Families and tourists visit to relax, enjoy sunsets, and indulge in local snacks. A spacious Innova rental ensures ample seating and storage space, making it ideal for family outings to Juhu Beach and nearby attractions."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a revered Hindu temple dedicated to Lord Ganesha and is one of the most visited spiritual sites in Mumbai. Devotees and tourists alike come for blessings, prayers, and to experience the spiritual ambiance. Renting an Innova offers a comfortable and stress‑free transport option, especially during festivals and peak visiting hours when public transport gets crowded."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "The Bandra Worli Sea Link is a modern cable‑stayed bridge connecting Bandra and Worli over the Arabian Sea. The bridge offers panoramic views of the skyline and sea and is a memorable route for city drives, especially at sunset. A rental Innova provides a smooth and scenic ride for larger groups while exploring this iconic urban landmark and nearby attractions."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a famous spiritual and cultural landmark located on an islet off Mumbai’s coast. The white marble structure surrounded by the sea draws visitors from diverse backgrounds who come for prayers and sightseeing. Renting an Innova allows tourists to reach this serene location comfortably without worrying about navigating city traffic or finding parking."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock‑cut temples located on Elephanta Island in Mumbai Harbour and are known for their elaborate stone carvings dedicated to Lord Shiva. Recognized as a UNESCO World Heritage Site, the caves attract history and culture enthusiasts. Renting an Innova provides a hassle‑free way to reach the ferry point at the Gateway of India and begin the cultural excursion with comfort."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large urban forest reserve within Mumbai that offers nature trails, wildlife viewing, and ancient Kanheri Caves. Nature lovers and families visit the park to enjoy outdoor activities and scenic greenery. A rental Innova ensures a comfortable ride for day trips and group outings to this natural retreat."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is one of Mumbai’s busiest and most vibrant shopping streets, known for its eclectic mix of boutiques, handicrafts, accessories, and cafes. Visitors often shop for souvenirs and local fashion while experiencing the lively atmosphere. Renting an Innova allows travelers to enjoy this shopping destination comfortably and integrate it into their full city sightseeing itinerary."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also known as Pherozeshah Mehta Gardens, are beautifully landscaped terraced gardens on Malabar Hill offering panoramic views of Marine Drive and the Arabian Sea. Visitors enjoy peaceful walks, photography, and relaxation in lush greenery. Renting an Innova makes it easy for families and groups to reach this scenic spot and enjoy a memorable day out in Mumbai."
  }
],



services: [
{
name: "Innova on Rent Mumbai",
description: "Innova on rent Mumbai service provides spacious and comfortable transportation for families, corporate travelers, and tourist groups traveling across the city and outstation destinations. The Toyota Innova is one of the most preferred multi-utility vehicles known for its comfort, reliability, and smooth highway performance. Our vehicles are well maintained and offer comfortable seating for long journeys with ample luggage space. Professional drivers ensure safe driving and punctual pickup services from homes, hotels, offices, railway stations, and Mumbai airport terminals. Air-conditioned interiors provide relaxed travel even during long-distance trips. Ideal for family travel, airport transfers, corporate travel, and outstation journeys."
},
{
name: "Innova Taxi Mumbai",
description: "Innova taxi Mumbai service offers dependable transportation across the city and for intercity travel. The Toyota Innova provides spacious seating and smooth ride quality suitable for both city rides and long-distance journeys. Our professional drivers ensure punctual pickup services and safe driving throughout the trip. Pickup is available from homes, hotels, offices, railway stations, and airport terminals across Mumbai. Air-conditioned vehicles ensure comfortable travel for families, corporate travelers, and tourist groups. Ideal for airport transfers, city tours, and outstation trips."
},
{
name: "Innova Cab Service Mumbai",
description: "Innova cab service Mumbai provides reliable and comfortable transportation for passengers looking for premium MPV travel in Mumbai. The vehicle offers spacious interiors, comfortable seating, and smooth ride quality for both city and highway journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family trips, airport travel, business travel, and outstation journeys."
},
{
name: "Innova Rental Mumbai",
description: "Innova rental Mumbai offers convenient vehicle hire options for travelers needing spacious and comfortable transportation. The Toyota Innova is perfect for family travel, business trips, and tourism journeys due to its large seating capacity and luggage space. Vehicles are well maintained and suitable for both city rides and interstate travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Ideal for airport travel, family vacations, and corporate transportation."
},
{
name: "Innova Airport Cab Mumbai",
description: "Innova airport cab Mumbai service provides reliable airport pickup and drop transportation for passengers traveling to and from Mumbai International Airport. The spacious MPV provides comfortable seating and luggage capacity suitable for airport travel. Professional drivers ensure punctual pickups according to flight schedules. Pickup services are available from homes, hotels, offices, and railway stations across Mumbai. Ideal for family airport transfers, corporate travel, and tourist transportation."
},
{
name: "Innova Outstation Cab Mumbai",
description: "Innova outstation cab Mumbai provides comfortable long-distance transportation for passengers traveling from Mumbai to destinations across Maharashtra and India. The Toyota Innova offers smooth highway performance, spacious seating, and comfortable travel for extended journeys. Professional drivers ensure safe interstate travel and punctual pickup services across Mumbai. Ideal for family vacations, pilgrimage tours, and corporate travel."
},
{
name: "Innova One Way Cab Mumbai",
description: "Innova one way cab Mumbai service provides economical travel options for passengers needing transportation without return charges. This option helps reduce travel costs while still enjoying the comfort of a premium MPV vehicle. Vehicles provide spacious seating and smooth ride quality suitable for long-distance travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai."
},
{
name: "Innova Round Trip Taxi Mumbai",
description: "Innova round trip taxi Mumbai service provides convenient travel options for passengers planning return journeys after visiting their destination. The vehicle remains available according to the travel plan ensuring comfortable transportation for both directions. Spacious interiors and comfortable seating make long-distance travel relaxed and convenient."
},
{
name: "Innova Cab Booking Mumbai",
description: "Innova cab booking Mumbai allows passengers to easily reserve Toyota Innova vehicles for city rides, airport transfers, or outstation journeys. Online and phone booking options provide quick confirmation and flexible ride scheduling. Vehicles provide spacious seating and comfortable travel suitable for families and groups."
},
{
name: "Innova Taxi Booking Online Mumbai",
description: "Innova taxi booking online Mumbai provides fast and convenient digital reservations for travelers planning comfortable transportation. Passengers can easily book their ride online and receive instant confirmation. Vehicles provide smooth ride quality and spacious seating suitable for city and outstation travel."
},
{
name: "Innova Cab Price Mumbai",
description: "Innova cab price Mumbai options provide transparent fare estimates based on travel distance, vehicle availability, and trip duration. Passengers can easily plan their travel budget with clear pricing structures. The Innova vehicle provides premium comfort and spacious seating suitable for family and group travel."
},
{
name: "Innova Taxi Fare Mumbai",
description: "Innova taxi fare Mumbai services offer flexible pricing depending on vehicle usage, travel distance, and trip duration. Passengers can enjoy comfortable MPV travel with clear fare structures and transparent billing policies."
},
{
name: "Cheap Innova Cab Mumbai",
description: "Cheap Innova cab Mumbai provides budget-friendly MPV travel options without compromising comfort or safety. Travelers can enjoy spacious seating, air-conditioned interiors, and smooth ride quality at economical pricing. Ideal for family travel and group transportation."
},
{
name: "Best Innova Rental Mumbai",
description: "Best Innova rental Mumbai service provides premium MPV transportation for passengers seeking comfortable and reliable travel. The Toyota Innova offers excellent ride quality, spacious seating, and luggage capacity suitable for both city and outstation journeys."
},
{
name: "Innova Family Cab Mumbai",
description: "Innova family cab Mumbai service provides spacious and comfortable transportation ideal for families traveling together. The MPV seating arrangement allows relaxed travel with luggage space suitable for vacation trips and family outings."
}
],

tableData: [
["Innova on Rent Mumbai","Innova Taxi Mumbai"],
["Innova Cab Service Mumbai","Innova Rental Mumbai"],
["Innova Airport Cab Mumbai","Innova Outstation Cab Mumbai"],
["Innova One Way Cab Mumbai","Innova Round Trip Taxi Mumbai"],
["Innova Cab Booking Mumbai","Innova Taxi Booking Online Mumbai"],
["Innova Cab Price Mumbai","Innova Taxi Fare Mumbai"],
["Cheap Innova Cab Mumbai","Best Innova Rental Mumbai"],
["Innova Family Cab Mumbai","Toyota Innova Taxi Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Spacious 7-Seater Travel Comfort",
    WhyChoosedescription: "Toyota Innova is one of the most comfortable 7-seater vehicles for group and family travel in Mumbai. With spacious seating, powerful AC, and large luggage capacity, it is ideal for city rides, airport transfers, and outstation journeys."
  },
  {
    WhyChooseheading: "Transparent Rental Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Innova on rent in Mumbai. Customers receive clear details about per-kilometer rates, driver allowance, and toll charges before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Innova rental service in Mumbai operates 24 hours a day. Whether you need an airport transfer, corporate travel, or outstation cab at night or early morning, we provide reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Well Maintained Vehicles",
    WhyChoosedescription: "Our Innova vehicles are regularly cleaned, sanitized, and maintained to provide a safe and comfortable travel experience for passengers."
  },
  {
    WhyChooseheading: "Flexible Local & Outstation Packages",
    WhyChoosedescription: "We offer flexible rental options including local hourly packages, airport pickup and drop, one-way trips, and outstation travel from Mumbai."
  },
  {
    WhyChooseheading: "Ideal for Families & Group Travel",
    WhyChoosedescription: "Innova cars can comfortably seat 6–7 passengers making them perfect for family trips, business travel, and group tours from Mumbai."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Mumbai",
    WhyChoosedescription: "Omshree Cabs provides doorstep pickup from homes, offices, hotels, railway stations, and airports across Mumbai for convenient travel."
  },
  {
    WhyChooseheading: "Trusted Cab Service in Mumbai",
    WhyChoosedescription: "Omshree Cabs is trusted by travelers for Innova car rental in Mumbai thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Innova on rent in Mumbai?", answer: "Yes, Omshree Cabs provides Toyota Innova rental services in Mumbai for local travel, airport transfers, and outstation trips." },
  { question: "What is the seating capacity of an Innova?", answer: "Toyota Innova comfortably seats 6 to 7 passengers with sufficient luggage space." },
  { question: "What is the per km rate for Innova rental in Mumbai?", answer: "Innova rental rates usually start around ₹14 to ₹17 per km depending on the travel distance and package type." },
  { question: "Can I book Innova for outstation travel?", answer: "Yes, Innova cars are commonly used for outstation trips from Mumbai to destinations like Pune, Nashik, Shirdi, Mahabaleshwar, and Goa." },
  { question: "Do you provide Innova airport pickup service?", answer: "Yes, Omshree Cabs provides Innova airport pickup and drop services at Mumbai Airport." },
  { question: "Are the vehicles air-conditioned?", answer: "Yes, all Innova vehicles provided by Omshree Cabs are fully air-conditioned." },
  { question: "Do you provide driver with the Innova rental?", answer: "Yes, all Innova rentals include a professional driver for safe and comfortable travel." },
  { question: "Can we book Innova for weddings or group travel?", answer: "Yes, Innova is a popular choice for wedding travel, family functions, and group transportation." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and wedding seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Shah",
    feedback:
      "We booked an Innova from Omshree Cabs for our family trip from Mumbai to Lonavala. The vehicle was spacious and the driver was very professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Mehta",
    feedback:
      "Excellent Innova rental service in Mumbai. Clean car, comfortable seating, and punctual pickup made our trip very pleasant.",
    rating: 5
  }
];









































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova On Rent Mumbai",
  "description": "Book a Toyota Innova on rent in Mumbai with Omshree Cab for airport transfers, outstation trips, one-way or round-trip journeys. Enjoy safe, comfortable, and spacious travel with Innova cab service at affordable rates for families, corporate trips, and group travel.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1120"
  }
};




  return (
    <div>
      


<Helmet>
  <title>Innova On Rent Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Rent an Innova in Mumbai with Omshree Cab for airport transfers, outstation trips, one-way or round trips. Safe, comfortable, and spacious Innova cab service for families and corporate travel." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/78.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovaonrentmumbai;